import { ErrorHandler } from '@src/components/ErrorHandler';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Skeleton as AbyssSkeleton } from '@uhg-abyss/web/ui/Skeleton';
import { motion } from 'framer-motion';
import React from 'react';

/**
 * Skeleton
 *
 * Displays a roughed-in idea/placeholder of what the UI should look like while the data is fetching from the API.
 *
 * @returns {JSX.Element}
 * @constructor
 */
export function Skeleton() {
  return (
    <ErrorHandler location="src/routes/private/MemberProfile/components/Skeleton/Skeleton.jsx">
      <motion.div
        animate="open"
        initial={{ opacity: 0 }}
        variants={{
          closed: { opacity: 0 },
          open: { opacity: 1 },
        }}
      >
        <Grid>
          <Grid.Col css={{ paddingTop: 'var(--abyss-space-lg)' }} span={{ xs: '100%' }}>
            <Heading offset={0}>
              <AbyssSkeleton height="50px" width="100%" />
            </Heading>
          </Grid.Col>
          <Grid.Col span={{ xs: '100%' }}>
            <AbyssSkeleton height="70px" width="100%" />
          </Grid.Col>
        </Grid>

        <Grid>
          <Grid.Col
            css={{ paddingTop: 'var(--abyss-space-lg)' }}
            span={{
              xs: '50%',
            }}
          >
            <AbyssSkeleton height="1000px" width="100%" />
          </Grid.Col>
          <Grid.Col
            css={{ paddingTop: 'var(--abyss-space-lg)' }}
            span={{
              xs: '50%',
            }}
          >
            <Grid>
              <Grid.Col
                span={{
                  xs: '100%',
                }}
              >
                <AbyssSkeleton height="775px" width="100%" />
              </Grid.Col>

              <Grid.Col
                span={{
                  xs: '100%',
                }}
              >
                <AbyssSkeleton height="200px" width="100%" />
              </Grid.Col>
            </Grid>
          </Grid.Col>
        </Grid>

        <Grid>
          <Grid.Col
            css={{ paddingTop: 'var(--abyss-space-lg)' }}
            span={{
              xs: '100%',
            }}
          >
            <AbyssSkeleton height="325px" width="100%" />
          </Grid.Col>
        </Grid>
      </motion.div>
    </ErrorHandler>
  );
}
